export const ADDON_ID = "storybook/theme-switch-addon";
export const TOOL_ID = `${ADDON_ID}/tool`;
export const PARAM_KEY = "theme";
